var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStocksActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 18a1 1 0 01-1 1h-16a1 1 0 01-1-1V7.49a1 1 0 01.386-.79l8-6.222a1 1 0 011.228 0l8 6.222a1 1 0 01.386.79V18zm-2-1V7.978l-7-5.444-7 5.444V17h14zm-12-4h10v2h-10v-2z",
    fill: "#12C1F9"
  })));
}
export default SvgStocksActive;